import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/prompt/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/prompt/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/prompt/FETCH_FAILURE'

const CREATE_REQUEST = 'contenthouse/prompt/CREATE_REQUEST'
const CREATE_SUCCESS = 'contenthouse/prompt/CREATE_SUCCESS'
const CREATE_FAILURE = 'contenthouse/prompt/CREATE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  errors: [],
  loaded: false,
  loading: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(){
  return {
    type: CREATE_FAILURE,
  }
}

export function loadAssetPrompts(assetId){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api(`/v1/prompts/asset/${assetId}`, {})
      .then(({ data }) => {
        dispatch(fetchSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function aiEditAsset(assetId, prompt, promptKey, customPrompt, asNewAsset = false, outputName){
  const config = {
    method: 'POST',
    data: {
      prompt,
      ...(promptKey ? { promptKey } : {}),
      ...(customPrompt ? { customPrompt } : {}),
      // CH-4304: true = NEW asset from the base; omitted = new version (CH-4255).
      ...(asNewAsset ? { asNewAsset: true } : {}),
      // CH-4304: the operator's name for the new asset (FE prefills the base's name).
      ...(asNewAsset && outputName ? { outputName } : {}),
    },
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api(`/v1/assets/${assetId}/ai-edit`, {}, config)
      .then(({ data }) => {
        dispatch(createSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure())

        return { success: false, errors }
      })

    return promise
  }
}

export function getAiEditStatus(requestId){
  return () => api(`/v1/ai-edits/${requestId}`, {})
    .then(({ data }) => ({ success: true, data }))
    .catch(error => ({ success: false, status: error?.response?.status, errors: handleError(error) }))
}

export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
      }
    default:
      return state
  }
}
